import { ConditionalLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import React from 'react';
import { Box } from '@mui/material';
import BaseTypography from 'core/components/typography/BaseTypography';
import { selectedImageInfoStyles } from 'apps/studio/studio-tab/components/actions-menu/selected-image-info/SelectedImageInfoStyles';
import { itemChipStyles } from 'core/layouts/components/settings-sidebar/selected-items-chips-component/components/item-chip/ItemChipStyles';
import BaseImage from 'core/components/image/BaseImage';
import ShowMoreComponent from 'apps/studio/studio-tab/components/ShowMoreComponent';

export default function SelectedImageInfo({ imageInfo, isShown }) {
	const isModel = imageInfo.model;
	const [hidePrompt, setHidePrompt] = React.useState(true);
	return (
		<ConditionalLayer isShown={isShown}>
			<Box id="selected-image-info" sx={selectedImageInfoStyles.selectedImageInfoCont}>
				<BaseTypography variant="b2_caption_medium" styles={{ color: 'colors.light3' }}>
					{isModel ? 'Model used:' : 'Style used:'}
				</BaseTypography>
				<Box sx={[itemChipStyles.selectedModelChip, selectedImageInfoStyles.infoChip]}>
					<Box id="selected-image-container" sx={itemChipStyles.selectedModelImageContainer}>
						<BaseImage src={isModel ? imageInfo.modelImage : imageInfo.styleImage} />
					</Box>
					<BaseTypography variant="b2_caption" styles={{ color: 'colors.light3' }}>
						{isModel ? imageInfo.modelLabel : imageInfo.styleLabel}
					</BaseTypography>
				</Box>
			</Box>
			<Box
				id="prompt-description"
				sx={[selectedImageInfoStyles.selectedImageInfoCont]}
				onClick={(e) => e.stopPropagation()}
			>
				<BaseTypography variant="b2_caption_medium" styles={{ color: 'colors.light3' }}>
					Prompt Description
				</BaseTypography>
				<BaseTypography variant="b2_caption" styles={selectedImageInfoStyles.promptDescription}>
					{imageInfo.prompt && (
						<ShowMoreComponent
							variant="tooltip_medium"
							hide={hidePrompt}
							value={imageInfo.prompt ?? ''}
							showMoreFunc={() => setHidePrompt(false)}
						/>
					)}
				</BaseTypography>
			</Box>
		</ConditionalLayer>
	);
}
